import type { FieldValidationError } from './parseValidationDetail';

export interface SectionRule<S extends string> {
  pattern: RegExp;
  section: S | ((match: RegExpMatchArray) => S);
}

/**
 * Маппит ошибки валидации полей в маркеры разделов навигации настроек.
 * Правила применяются по порядку, первое совпадение побеждает.
 * Fallback для «остальных» путей — правило с универсальным паттерном.
 */
export function mapFieldErrorsToSections<S extends string>(
  errors: FieldValidationError[],
  rules: SectionRule<S>[],
): Partial<Record<S, boolean>> {
  const sections: Partial<Record<S, boolean>> = {};

  errors.forEach(({ path }) => {
    const applied = rules.find((rule) => rule.pattern.test(path));
    if (!applied) return;

    const match = applied.pattern.exec(path);
    if (!match) return;

    const section = typeof applied.section === 'function'
      ? applied.section(match)
      : applied.section;
    sections[section] = true;
  });

  return sections;
}
